import { render, staticRenderFns } from "./EconomyExpenses.vue?vue&type=template&id=21bfe8da&scoped=true"
import script from "./EconomyExpenses.vue?vue&type=script&lang=js"
export * from "./EconomyExpenses.vue?vue&type=script&lang=js"
import style0 from "./EconomyExpenses.vue?vue&type=style&index=0&id=21bfe8da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21bfe8da",
  null
  
)

export default component.exports